import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";

function PresupuestosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PRESUPUESTOS = process.env.REACT_APP_URL_PRESUPUESTOS;
  const URL_PERIODOS_GASTOS = process.env.REACT_APP_URL_PERIODOS_GASTOS;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;

  const [importe, setImporte] = useState("");
  const [periodos, setPeriodos] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");

  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setImporte("");
    setSelectedPeriodo([]);
    setSelectedDepartamento([]);
    setValidaBoton(true);
  };

  useEffect(() => {
    axios
      .get(URL_PERIODOS_GASTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPeriodos = res.data;
        setPeriodos(allPeriodos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const savePresupuestos = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_PRESUPUESTOS,
        {
          importe,
          periodosGastos: selectedPeriodo,
          departamentos: selectedDepartamento,
          utilizado: 0,
          disponible: importe,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Presupuesto",
            detalle: ` Periodo: ${selectedPeriodo} / Departamento: ${selectedDepartamento}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
        setValidaBoton(true)
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.presupuestos_create ? (
        <div className="card container col-sm-4">
          <h3 align="center">Nuevo Presupuesto</h3>
          <Form onSubmit={savePresupuestos}>
            <Row>
              <Col md={6}>
                <Label className="mr-sm-2">Periodo</Label>
                <Input
                  type="select"
                  value={selectedPeriodo}
                  required
                  onChange={(e) => {
                    setSelectedPeriodo(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Periodo</option>
                  {periodos
                    .sort((a, b) => (a.fecha_inicio < b.fecha_inicio ? 1 : -1))
                    .map((c) => {
                      return (
                        <option value={c._id}>
                          {c.name} Ciclo {c.ciclos[0].name}
                        </option>
                      );
                    })}
                </Input>
              </Col>
           
              <Col md={6}>
                <Label className="mr-sm-2">Departamento</Label>
                <Input
                  type="select"
                  value={selectedDepartamento}
                  required
                  onChange={(e) => {
                    setSelectedDepartamento(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Departamento</option>
                  {departamentos
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((d) => {
                      return <option value={d._id}>{d.name}</option>;
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Importe
                </Label>
                <Input
                  type="text"
                  placeholder="Importe"
                  value={importe}
                  required
                  onChange={(e) => {
                    setImporte(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Col>
              <Row>
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>
                )}
                <div>
                  <SweetAlert
                    show={text}
                    title="Creado con Exito"
                    // text="SweetAlert in React"
                    onConfirm={() => {
                      setText(false);
                      window.location.href = "/Presupuestos";
                    }}
                  />
                </div>
                <Button
                  href="/Presupuestos"
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Row>
            </Col>
          </Form>
        </div>
      ) : undefined}
      
    </>
  );
}

export default PresupuestosCreate;
